import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataTypePregunta } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

const cardLabel = (card: AllCardsType) => formatCardLabel(card)

export const interpret = (
    cards: AllCardsType[],
    data: DataTypePregunta,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    const consult = `Quiero que interpretes una **Tirada de Mensaje de tus Guías** con 10 cartas, ayudando al consultante ${
        data.consultante
    } a recibir el mensaje de sus guías espirituales, ángeles o energías de acompañamiento, ${
        data.consulta.length > 0
            ? 'ten en cuenta en la tirada la siguiente consulta que realiza el consultante: ' +
              data.consulta +
              ','
            : ''
    } según estas cartas: **Quién te está guiando ahora — Quién conecta (¿qué guía, ángel o energía se está acercando en este momento?):** ${cardLabel(
        cards[0]
    )}, **El mensaje principal — Mensaje central (¿cuál es el mensaje más importante que quieren darte ahora?):** ${cardLabel(
        cards[1]
    )}, **Qué te están pidiendo soltar — Liberación (¿qué creencia, apego, situación o emoción te están pidiendo soltar?):** ${cardLabel(
        cards[2]
    )}, **Qué te están invitando a activar — Activación (¿qué energía, cualidad o acción te están invitando a incorporar?):** ${cardLabel(
        cards[3]
    )}, **Consejo para el momento actual — Consejo práctico (¿qué te recomiendan hacer o cómo transitar este momento?):** ${cardLabel(
        cards[4]
    )}, **Apoyo o herramienta disponible — Apoyo disponible (¿qué ayuda o recurso espiritual tenés disponible ahora?):** ${cardLabel(
        cards[5]
    )}, **Área que necesitan que mires — Área de atención (¿hay algo que estén queriendo que prestes atención? a veces es una advertencia suave):** ${cardLabel(
        cards[6]
    )}, **Cómo podés conectar más con ellos — Práctica recomendada (¿qué podés hacer para fortalecer tu conexión espiritual?):** ${cardLabel(
        cards[7]
    )}, **Energía que viene si seguís su consejo — Resultado probable (¿qué energía o cambio se abre si seguís este mensaje?):** ${cardLabel(
        cards[8]
    )} y **Mensaje de cierre / bendición — Cierre sanador (¿qué quieren que sepas o recuerdes como cierre?):** ${cardLabel(
        cards[9]
    )}. Explica detalladamente cada carta y su significado en la posición donde ha salido. Teje una lectura coherente como un mensaje canalizado de las guías: conecta quién guía, el mensaje central, lo que hay que soltar y activar, y el cierre con bendición. Mantén un tono espiritual, cálido, respetuoso y claro, sin ser dogmático ni imponer creencias. Detecta señales de apoyo, advertencias suaves y oportunidades de conexión. Proporciona consejos prácticos y espirituales accesibles. Mantén un tono profesional, empático y comprensible. Dirígete directamente al consultante, no utilices la tercera persona refiriéndote al consultante, aún cuando las consultas se encuentren en tercera persona, adapta la respuesta para que quede en segunda persona. Incluye además en 2 párrafos después de la lectura, una respuesta directa para el consultante y un consejo final (extra-tarot).`

    return {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: data.consulta,
        cards,
        type,
    }
}
